import {createSelector} from "reselect";
import moment from "moment";
import {DATE_FORMATS, parse} from "utils/Date";
import {initialState} from "./reducer";

/**
 * Direct selector to the patientDataPage state domain
 */

const selectPatientDataPageDomain = state =>
  state.get("patientDataPage", initialState);

/**
 * Other specific selectors
 */
export const makeSelectPatient = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("patient"),
  );

export const makeSelectPatientLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("patientLoading"),
  );

export const makeSelectPatientUpdateFailed = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("patientUpdateFailed"),
  );

export const makeSelectPatientUpdateLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("patientUpdateLoading"),
  );

/**
 * Delete Patient
 */
export const makeSelectDeletePatientLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("deletePatientLoading"),
  );

export const makeSelectPatientDeleted = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("deleted"),
  );

export const makeSelectPatientDeletedFailed = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("deleteFailed"),
  );

/**
 * Treatment history
 */
export const makeSelectTreatmentHistory = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("treatmentHistory").toJS(),
  );
export const makeSelectTreatmentHistoryLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("treatmentHistoryLoading"),
  );

/**
 * planned treatments
 * Select currently planned treatments today and after
 */
export const makeSelectTreatments = () =>
  createSelector(selectPatientDataPageDomain, subState => {
    const treatmentPlan = subState.get("plannedTreatments");
    if (!treatmentPlan || !treatmentPlan.plannedTreatments) {
      return [];
    }

    const treatments = treatmentPlan.plannedTreatments;
    return treatments.filter(treatment => {
      if (!treatment.planned) {
        return false;
      }

      const date = parse(treatment.planned_date_time_from, DATE_FORMATS.BUMBAL);
      return date.isSameOrAfter(moment(), "d");
    });
  });

export const makeSelectTreatmentsLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("plannedTreatmentsLoading"),
  );

export const makeSelectProductPlanLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("productPlanLoading"),
  );


export const makeSelectMessageDetailsLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("messageDetailLoading"),
  );

export const makeSelectMessageDetails = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("messageDetail"),
  );

export const makeSelectTreatmentPlan = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("plannedTreatments"),
  );

export const makeSelectProductPlan = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("productPlan"),
  );

export const makeSelectMessages = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("messages").toJS(),
  );

export const makeSelectStatusOpenCount = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("statusOpenCount"),
  );

export const makeSelectMessagesTotal = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("total"),
  );

export const makeSelectMessagesCurrentPage = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("currentPage"),
  );

export const makeSelectCloseTreatmentPlanLoading = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("closeTreatmentPlanLoading"),
  );

/**
 * Remake productOrder
 */
export const makeSelectRemakeProductOrder = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("remakeProductOrder"),
  );

/**
 * Refitting treatment
 */
export const makeSelectRefittingPlannedTreatment = () =>
  createSelector(selectPatientDataPageDomain, subState =>
    subState.get("refittingPlannedTreatment"),
  );

/**
 * Default selector used by PatientDataPage
 */

const makeSelectPatientDataPage = () =>
  createSelector(selectPatientDataPageDomain, substate => substate.toJS());

export default makeSelectPatientDataPage;
export { selectPatientDataPageDomain };
